import { RouteObject } from '@rocketlane/rocket-router';
import { SignalAgentsRemote } from 'components/pages/signal-agents-remote';

export const signalAgentsRoutes: RouteObject[] = [
  {
    path: '/signal-agents/*',
    element: <SignalAgentsRemote />,
  },
];
